import { useQuery } from '@apollo/client';
import { buttonV2Class } from '@synoptic/ui-kit/button-v2/button-v2.css.js';
import { ArrowRightIcon } from '@synoptic/ui-kit/icons/react/arrow-right.js';
import { SkeletonV2 } from '@synoptic/ui-kit/skeleton-v2/skeleton-v2.js';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useId } from 'react';
import { gql } from '@/__generated__/index.ts';
import { StreamPackageCardLinkV2 } from '@/components/stream-package-card-v2/stream-package-card-link-v2.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  explorePackageCardGridV2,
  explorePackageCardSkeletonV2,
  exploreSectionHeaderV2,
  exploreSectionHeadingV2,
  exploreSectionSubtitleV2,
  exploreSectionTitleV2,
  exploreSectionV2,
} from './explore-page-v2.css.ts';

const ExploreStreamPackagesQuery = gql(`
  query ExploreStreamPackagesQuery {
    streamPackages(queryType: FEATURED, limit: 4, nextToken: null) {
      items {
        ...StreamPackageCardV2Fragment
      }
      nextToken
    }
  }
`);

const SKELETON_COUNT = 4;

export const StreamPackageCardsFallbackV2 = () => (
  <div className={explorePackageCardGridV2}>
    {Array.from({ length: SKELETON_COUNT }, (_, index) => (
      <SkeletonV2
        key={index}
        className={explorePackageCardSkeletonV2}
        height={540}
        width="100%"
      />
    ))}
  </div>
);

export const ExploreStreamPackagesSectionV2 = () => {
  const titleId = useId();
  const toast = useToast();
  const { data, loading } = useQuery(ExploreStreamPackagesQuery, {
    fetchPolicy: 'cache-and-network',
    onError: () => {
      toast.error({
        title: 'Failed to fetch stream packages',
      });
    },
  });

  const streamPackages = data?.streamPackages?.items;
  const showSkeletons = loading && !streamPackages?.length;

  return (
    <section className={exploreSectionV2} aria-labelledby={titleId}>
      <header className={exploreSectionHeaderV2}>
        <div className={exploreSectionHeadingV2}>
          <h2 id={titleId} className={exploreSectionTitleV2}>
            Stream Packages
          </h2>
          <p className={exploreSectionSubtitleV2}>
            Bundles of related streams from one publisher at a single monthly
            price.
          </p>
        </div>
        <Link className={buttonV2Class.secondary} to={paths.streamPackages}>
          See all
          <ArrowRightIcon />
        </Link>
      </header>
      {showSkeletons ? (
        <StreamPackageCardsFallbackV2 />
      ) : (
        <div className={explorePackageCardGridV2}>
          {streamPackages?.map((streamPackage) => (
            <StreamPackageCardLinkV2
              key={streamPackage.id}
              streamPackage={streamPackage}
            />
          ))}
        </div>
      )}
    </section>
  );
};
